import React, { useState } from "react";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { blue } from "@mui/material/colors";

import TagRolePropertiesDialog from "components/TagRolePropertiesDialog";
import { STATES_ROLE } from "services/RolesService";

const StateReportingOption = (props) => {
  const [roleDialogOpen, setRoleDialogOpen] = useState(false);

  const { options = {}, setOptions, tagsSelected } = props;
  const { statereporting: stateReportingOptions = {} } = options;
  const { outputUnit: summaryUnit = "percent" } = stateReportingOptions;

  const setSummaryUnit = (event) =>
    setOptions({ statereporting: { outputUnit: event.target.value } });

  const tag = Object.values(tagsSelected ?? {})[0];

  return (
    <FormControl
      variant="standard"
      margin="dense"
      style={{ width: "calc(100% - 48px)", margin: 24 }}
    >
      <FormLabel>Display values as:</FormLabel>
      <RadioGroup
        aria-label="summaryUnit"
        name="summaryUnit"
        value={summaryUnit}
        onChange={(event) => setSummaryUnit(event)}
        row
      >
        <FormControlLabel
          value="percent"
          control={<Radio />}
          label="Percentage of time"
        />
        <FormControlLabel value="time" control={<Radio />} label="Total time" />
        <FormControlLabel
          value="count"
          control={<Radio />}
          label="Transitions"
        />
      </RadioGroup>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Typography
          variant="caption"
          style={{ fontSize: "0.66rem", fontStyle: "italic" }}
        >
          The state levels are configured in the Device Tags properties.
        </Typography>
        <Tooltip
          title="Click to view/modify states properties"
          onClick={(e) => {
            setRoleDialogOpen(true);
          }}
        >
          <OpenInNewIcon
            fontSize="small"
            sx={{ color: blue[500], cursor: "pointer" }}
          />
        </Tooltip>
      </div>
      <TagRolePropertiesDialog
        open={roleDialogOpen}
        setOpen={setRoleDialogOpen}
        tag={tag}
        role={STATES_ROLE}
      />
    </FormControl>
  );
};

export default StateReportingOption;
